import React from "react";
import { useParams } from "react-router-dom";

import PageHeader from "./components/PageHeader";
import StatsCards from "./components/StatsCards";
import DataTable from "./components/DataTable";
import Pagination from "./components/Pagination";
import PageModal from "./components/PageModal";
import PageTitle from "./components/PageTitle";

import usePageData from "./hooks/usePageData";
import Loader from "../Loader";

const CommonPage = () => {
  const { pageCode } = useParams();

  const {
    config,

    data,

    stats,

    loading,

    search,
    setSearch,

    page,
    setPage,

    totalPages,
    totalEntries,

    entriesPerPage,
    setEntriesPerPage,

    handleDelete,
    handleStatusToggle,

    handleSave,

    showModal,
    setShowModal,

    modalMode,
    setModalMode,

    selectedRow,
    setSelectedRow,
  } = usePageData(pageCode);

  /**
   * LOADING STATE
   */
  if (!config) return <div><Loader/></div>;

  return (
    <>
      {/* ============================= */}
      {/* STATS */}
      {/* ============================= */}

      {stats?.length > 0 && <StatsCards stats={stats} />}

      {/* ============================= */}
      {/* TITLE */}
      {/* ============================= */}

      <PageTitle title={config.title} />

      {/* ============================= */}
      {/* HEADER */}
      {/* ============================= */}

      <PageHeader
        title={config.title}
        route={config.page_route}
        search={search}
        setSearch={setSearch}
        entriesPerPage={entriesPerPage}
        setEntriesPerPage={setEntriesPerPage}
        addLabel={config.addLabel || "Add"}
        onAdd={() => {
          setSelectedRow(null);

          setModalMode("Add");

          setShowModal(true);
        }}
      />

      {/* ============================= */}
      {/* TABLE */}
      {/* ============================= */}

      <DataTable
        columns={config.columns}
        data={data}
        route={config.page_route}
        loading={loading}
        onEdit={(row) => {
          setSelectedRow(row);

          setModalMode("Edit");

          setShowModal(true);
        }}
        onView={(row) => {
          setSelectedRow(row);

          setModalMode("View");

          setShowModal(true);
        }}
        onDelete={handleDelete}
        onStatusToggle={handleStatusToggle}
      />

      {/* ============================= */}
      {/* PAGINATION */}
      {/* ============================= */}

      <Pagination
        page={page}
        totalPages={totalPages}
        totalEntries={totalEntries}
        entriesPerPage={entriesPerPage}
        fetchData={setPage}
      />

      {/* ============================= */}
      {/* MODAL */}
      {/* ============================= */}

      <PageModal
        show={showModal}
        onClose={() => setShowModal(false)}
        config={config}
        mode={modalMode}
        data={selectedRow}
        onSave={handleSave}
      />
    </>
  );
};

export default CommonPage;
